"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRpcStreamingClient = instanceOfRpcStreamingClient;
exports.hasProtocol = hasProtocol;
function instanceOfRpcStreamingClient(client) {
    return typeof client.listen === "function";
}
// Helpers for all RPC clients
function hasProtocol(url) {
    return url.search("://") !== -1;
}
//# sourceMappingURL=rpcclient.js.map